import { Step } from "react-joyride";

const organizationSettingsPageTourSteps: Step[] = [
  {
    target: ".tour-choose-logo",
    content: "Choose a logo for your company. Must be a JPEG or PNG file.",
    skipScroll: true,
  },
  {
    target: ".tour-organization-name",
    content: "Your company name as it will appear on proposals and emails.",
    skipScroll: true,
  },
  {
    target: ".tour-organization-phone-email",
    content:
      "Your organization’s phone number and email address. Usually an office administrator or similar.",
    skipScroll: true,
  },
  {
    target: ".tour-organization-timezone",
    content: "Your organization’s time zone. This determines when automated emails are sent.",
    placement: "top",
    skipScroll: true,
  },
  {
    target: ".tour-organization-sales-goal",
    content: "Enter the yearly sales goal for the entire company.",
    placement: "top",
    skipScroll: true,
  },
  {
    target: ".tour-organization-info-save",
    content: "Click here to save your settings.",
    placement: "top",
  },
  {
    target: ".tour-add-document",
    content:
      "Optional documents, such as a COI or W9, that can be attached to your proposals, etc.",
    placement: "top",
  },
  {
    target: ".tour-average-working-hours",
    content: "These hours are used to estimate days spent on a job.",
    placement: "top",
  },
  {
    target: ".tour-organization-settings-save",
    content: "Click here to save these settings.",
    placement: "top",
  },
  {
    target: ".tour-add-sales-tax",
    content: "This is an optional input to add tax rates for your services.",
    placement: "top",
  },
  {
    target: ".tour-sales-tax-default",
    content:
      "Selecting ‘Default’ will apply these taxes to every proposal. These can still be added or removed later.",
    placement: "top",
  },
  {
    target: ".tour-organization-address-actions",
    content: "Now click here and choose 'Update Address' to set your company's primary address.",
    skipScroll: true,
  },
];

export default organizationSettingsPageTourSteps;
